import {ChangeDetectionStrategy, Component, signal} from '@angular/core';
import {IconsService} from '@my7n/ui';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class App {
  protected readonly title = signal('availability-app');

  constructor(
    private iconsService: IconsService,
  ) {
    this.iconsService.generateCustomMaterialIcons();
  }
}
